import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { SystemOverviewSection } from "@/components/dashboard/sections/SystemOverviewSection";
import { PlatformHealthSection } from "@/components/dashboard/sections/PlatformHealthSection";
import { BrokerStatusSection } from "@/components/dashboard/sections/BrokerStatusSection";
import { SynchronizationSection } from "@/components/dashboard/sections/SynchronizationSection";
import { CertificationSection } from "@/components/dashboard/sections/CertificationSection";
import { SystemInformationSection } from "@/components/dashboard/sections/SystemInformationSection";

export function DashboardPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Live backend status, read directly from Falcon's REST API — no calculated values.
        </Typography>
      </Box>
      <InformationGrid>
        <SystemOverviewSection />
        <PlatformHealthSection />
        <BrokerStatusSection />
        <SynchronizationSection />
        <CertificationSection />
        <SystemInformationSection />
      </InformationGrid>
    </ResponsiveContainer>
  );
}
